<template>
  <div v-if="text" :class="$style.mainPageSeoText">
    <Markdown :text="text" :class="$style.textParagraph" :auto-link-parse="autoLinkParse" />
    <Markdown
      :text="hiddenText"
      :class="[$style.textParagraph, { [$style.hidden]: isTextHidden }]"
      :auto-link-parse="autoLinkParse"
    />
    <BitButton
      v-if="hiddenText"
      type="secondary"
      :class="[
        $style.mainPageSeoTextButton,
        { [$style.mainPageSeoTextButtonActive]: !isTextHidden },
      ]"
      @click="toggleHiddenText()"
    >
      <template #prependIcon>
        <DropdownWrrowDown />
      </template>
      <span v-if="isTextHidden">{{ showMore }}</span>
      <span v-else>{{ showLess }}</span>
    </BitButton>
  </div>
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import { ref, watch } from 'vue';
import Markdown from '~/components/markdown.vue';
import DropdownWrrowDown from '~/public/images/common/ico_dropdown_arrow_down.svg?component';
import { useStoreSsPlayer } from '~/stores/softswiss/player';

defineProps({
  text: {
    type: String,
    required: true,
  },
  autoLinkParse: {
    type: Boolean,
    required: true,
  },
  hiddenText: {
    type: String,
    required: true,
  },
  showMore: {
    type: String,
    required: true,
  },
  showLess: {
    type: String,
    required: true,
  },
});

const storeSsPlayer = useStoreSsPlayer();

const isTextHidden = ref(false);

watch(
  () => storeSsPlayer.isPlayerAuthorised,
  () => {
    isTextHidden.value = storeSsPlayer.isPlayerAuthorised;
  }
);

const toggleHiddenText = () => {
  isTextHidden.value = !isTextHidden.value;
};

onMounted(() => {
  isTextHidden.value = storeSsPlayer.isPlayerAuthorised;
});
</script>

<style lang="scss" module src="./seoText.scss"></style>
